import { TeamsViewAction, TeamsViewActionsNames } from "./actions";
import { ISort } from "./interfaces";

export interface ITeamsViewState {
  selectedTeamId: string;
  focusedColumn: number;
  sort: ISort;
}

const initialState: ITeamsViewState = {
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
  selectedTeamId: null,
  focusedColumn: 0,
  sort: {
    field: "name",
    desc: false,
  },
};

export function teamsViewReducer(state: ITeamsViewState = initialState, action: TeamsViewAction): ITeamsViewState {
  switch (action.type) {
    case TeamsViewActionsNames.SET_SELECTED_TEAM: {
      const { selectedTeamId } = action.payload;
      return {
        ...state,
        selectedTeamId,
      };
    }

    case TeamsViewActionsNames.SET_FOCUSED_COLUMN: {
      const { focusedColumn } = action.payload;
      return { ...state, focusedColumn };
    }

    case TeamsViewActionsNames.SET_LIST_SORTING: {
      const { field, desc } = action.payload;
      return {
        ...state,
        sort: { field, desc },
      };
    }

    default:
      return state;
  }
}
